module.exports = __webpack_public_path__ + "static/media/uparrow.8db898a1.svg";